import { getLocale } from "../runtime";

const da_easteregg5 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Et øjeblik med ro i en travl dag. Vi får dig på rette spor snart.`
};

const en_easteregg5 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `A moment of calm in a busy day. We'll get you back on track soon.`
};

const es_easteregg5 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Un momento de calma en un día ocupado. Te pondremos en el camino correcto pronto.`
};

const fi_easteregg5 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Rauhallinen hetki kiireisessä päivässä. Pääset pian takaisin oikealle tielle.`
};

const nb_easteregg5 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Et øyeblikk med ro i en travel dag. Vi får deg på rett spor snart.`
};

const sv_easteregg5 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ett ögonblick av lugn i en hektisk dag. Vi får dig på rätt spår snart.`
};

const easteregg5 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_easteregg5(inputs)
	if (locale === "en") return en_easteregg5(inputs)
	if (locale === "es") return es_easteregg5(inputs)
	if (locale === "fi") return fi_easteregg5(inputs)
	if (locale === "nb") return nb_easteregg5(inputs)
	if (locale === "sv") return sv_easteregg5(inputs)
	return "easterEgg5";
};

export { easteregg5 as "easterEgg5" };